<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">系统管理    /</div>
        <div class="box-header-right">
          <div>字典管理</div>
        </div>
      </div>
    </div>
    <div class="section" v-if="st == 1">
      <div class="biaodan">
        <div class="botton-box">
          <el-button
            size="mini"
            class="addButton"
            @click="getchildeditDialog"
          >添加</el-button
          >
          <el-button size="mini" type="danger" slot="reference" style="margin-left: 10px;" @click="batchdelete">批量删除</el-button>
        </div>
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form
              :inline="true"
              label-position="right"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="字典名称">
                <el-input
                  v-model="form.itemName"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入字典名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="字典类型">
                <el-input
                  v-model="form.dictType"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入字典类型"
                ></el-input>
              </el-form-item>
              <el-form-item label="状态">
                <el-select
                  style="width: 150px"
                  size="mini"
                  placeholder="请选择字典状态"
                  clearable
                  v-model="form.status"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="创建时间">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="form.startTime"
                  style="width: 150px"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="mini"
                ></el-date-picker>
                <span>到</span>
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 150px"
                  size="mini"
                  type="date"
                  placeholder="选择日期"
                  v-model="form.endTime"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button type="primary" @click="onSearch"  class="search"    size="mini">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="table_name"
              highlight-current-row
              :data="tableData"
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333 ',
                textAlign: 'center',
              }"
              row-class-name="classname"
              row-key="id"
              border
              @selection-change="handleSelectionChange"
              max-height="650"
            >
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                align="center"
                prop="dictName"
                label="字典名称"
                width="250"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.dictName}}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="createUsername"
                label="创建人姓名	"

                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.createUsername}}</div>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="dictType"
                label="字典分类"
                :show-overflow-tooltip="true"
              >
                <template  slot-scope="scope">
                  <span>{{ scope.row.data.dictType }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="状态"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.data.status == true">启用</div>
                  <div v-if="scope.row.data.status == false">停用</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="updateTime"
                label="最后修改时间"
                width="300"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.updateTime}}</div>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="remark"
                label="备注"
                width="200"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.remark}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                fixed="right"
                width="320px"
              >
                <template slot-scope="scope">
                  <el-button
                    style="margin-left: 10px;color:#3666EA"
                    type="text"
                    @click="getValueDialog(scope.row.data)"
                  >编辑</el-button>
                  <el-button
                    type="text"
                    style="margin-left: 10px;color:#3666EA"
                    @click="getDetailData(scope.row.data)"
                  >字典条目</el-button>
                  <el-popconfirm
                    title="确定删除吗？"
                    trigger="click"
                    @confirm="deleteType(scope.row.data)"
                  >
                    <el-button                     type="text"
                                                   slot="reference" style="margin-left: 10px;color:#ED6363"
                    >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            :page-size="page.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div>
      </div>
    </div>


    <div class="section" v-if="st == 2">
      <div class="black">
        <el-page-header @back="goBack"></el-page-header>
      </div>
      <div class="biaodan">
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form
              :inline="true"
              label-position="right"
              class="demo-form-inline"
              :model="formData"
            >
              <el-form-item label="字典标签">
                <el-input
                  v-model="formData.itemLabel"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入字典名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="状态">
                <el-select
                  style="width: 150px"
                  size="mini"
                  placeholder="请选择字典类型"
                  clearable
                  v-model="formData.status"
                >
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button type="primary" @click="onSearchTwo"   class="search"  size="mini">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
<!--      getchildeditDialogTwo-->
      <div class="botton-box">
        <el-button
          icon="el-icon-plus"
          size="mini"
          class="addButton"
          @click="getchildeditDialogTwo('add')">添加</el-button>
        <el-popconfirm
          title="确定删除吗？"
          trigger="click"
          @confirm="batchdeleteTwo()">
          <el-button size="mini" type="danger" slot="reference" style="margin-left: 10px;">批量删除</el-button>
        </el-popconfirm>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="table_name"
              highlight-current-row
              :data="tableDataTwo"
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333 ',
                textAlign: 'center',
              }"
              row-class-name="classname"
              row-key="id"
              border
              lazy
              :load="treeLoadSon"
              :tree-props="{children: 'children', hasChildren: 'haveSon'}"
              max-height="650"
              ref="multipleTable"
              align="center"
              @selection-change="handleSelectionChangeTwo"
              :cell-style="{ textAlign: 'center' }"
            >
              <el-table-column
                type="selection"
                width="50"
                label="序号"
                align="center"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="itemName"
                label="字典名称"
                width="250"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.data.itemName">{{scope.row.data.itemName}}</div>
                  <div v-if="scope.row.data.dictName">{{scope.row.data.dictName}}</div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="itemLabel"
                label="字典标签"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.itemLabel}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createUsername"
                label="创建人姓名	"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.createUsername}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="dictType"
                label="字典分类"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.dictType}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="状态"
              >
                  <template slot-scope="scope">
                    <div v-if="scope.row.data.status == true">启用</div>
                    <div v-if="scope.row.data.status == false">停用</div>
                  </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                width="300"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.createTime}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                width="200"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.data.remark}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                fixed="right"
                width="200"
              >
                <template slot-scope="scope">
                  <el-button
                    style="margin-left: 10px;color:#3666EA"
                    type="text"
                    @click="getchildeditDialogTwo('son',scope.row.data)"
                  >添加子字典</el-button
                  >
                  <el-button
                    style="margin-left: 10px;color:#3666EA"
                    type="text"
                    @click="getValueDialogTwo(scope.row.data)"
                  >编辑</el-button
                  >
                  <el-popconfirm
                    title="确定删除吗？"
                    trigger="click"
                    @confirm="deleteTypeTwo(scope.row.data)"
                  >
                    <el-button    style="margin-left: 10px;color:#ED6363"
                                  type="text" slot="reference"
                    >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChangeTwo"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalTwo"
            background
            :page-size="pageTwo.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChangeTwo"
            :current-page.sync="currentPageTwo"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div>
      </div>
    </div>



    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="true"
      :close-on-click-modal="false">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px">
          <el-form-item label="字典名称"
                        prop="dictName">
            <el-input v-model="ruleForm.dictName"></el-input>
          </el-form-item>
          <el-form-item label="字典类型"
                        prop="dictType">
            <el-input v-model="ruleForm.dictType"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              size="medium"
              placeholder="请选择字典类型"
              clearable
              v-model="ruleForm.status"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序"
                        prop="dictOrder">
            <el-input v-model="ruleForm.dictOrder"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea"
                      v-model="ruleForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
      <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
      <el-button type="primary"
                 class="search"   size="mini"
                 @click="cancelcerat()">确 定</el-button>
    </span>
    </el-dialog>

    <el-dialog class="addValueDialog"
               width="30%"
               :modal="true"
               :title="titleTwo" :visible.sync="dialogVisibleTwo">
      <div>
        <el-form
                 :model="ruleFormTwo"
                 :rules="rules"
                 label-width="120px"
                 ref="ruleForm"
                 class="demo-ruleForm">
          <el-form-item label="字典类型">
            <el-input v-model="ruleFormTwo.dictType"
                      :disabled="true" />
          </el-form-item>
          <el-form-item label="数据标签"
                        prop="dictLabel">
            <el-input v-model="ruleFormTwo.itemLabel"
                      placeholder="请输入数据标签" />
          </el-form-item>
          <el-form-item label="数据名称"
                        prop="dictValue">
            <el-input v-model="ruleFormTwo.itemName"
                      placeholder="请输入数据键值" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              size="medium"
              placeholder="请选择字典类型"
              clearable
              v-model="ruleFormTwo.status"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序"
                        prop="dictValue">
            <el-input v-model="ruleFormTwo.itemOrder"
                      placeholder="请输入排序" />
          </el-form-item>
          <el-form-item label="描述">
            <el-input type="textarea"
                      v-model="ruleFormTwo.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
      <el-button @click="dialogVisibleTwo = false"  size="mini">取 消</el-button>
      <el-button type="primary"
                 class="search"   size="mini"
                 @click="cancelceratTwo">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>
<script>
import { DictionaryTypeList,DictionaryItemList, dictTypeOption, AddDictionaryType, DeleteDictionaryType,dictItemAdd } from "@/api/systemManagement";
import {dictItemRoot, setDictTypeBatchDelete, setItemBatchDelete, userType} from "../../../api/systemManagement";
export default{
  data(){
    return{
      tableDataTwo: [],
      dialogVisibleTwo: false,
      currentPageTwo: '1',
      dialogVisible: false,
      st: 1,
      totalTwo: '',
      statusOptions: [
        {value: 1, label: '启用'},
        {value: 0, label: '停用'}
      ],
      ruleForm:{
        dictName: '',
        dictType: '',
        status: 1,
        remark: '',
        id: '',
        dictOrder: null,
      },
      entryList: [],
      optionList:[],
      total: null,
      title: '添加字典项',
      titleTwo: '添加字典项数据',
      currentPage: 1,
      form: {
        dictType: '',
        status: '',
        itemName: '',
        startTime: '',
        endTime: '',
      },
      tableData: [],
      page: {
        page: 1,
        size: 10
      },
      dictionariesList: [],
      formData: {
        itemLabel: '',
        status: '',
        dictType: '',
      },
      ruleFormTwo: {
        itemLabel: '',
        itemName: '',
        status: 1,
        remark: '',
        id: '',
        dictType: '',
        pid: '',
        itemOrder: null,
      },
      dictionariesListTwo: [],
      pageTwo: {
        page: 1,
        size: 10
      },
      stateList: [
        {label: '全部', value: ''},
        {label: '停用', value: 0},
        {label: '正常', value: 1},
      ],
      rules: {
        dictName: [
          { required: true, message: '请输入字典名称', trigger: 'blur' },
        ],
        dictType: [
          { required: true, message: '请输入字典类型', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.queryDictionaries()
    this.queryOptionList()
    this.st = 1
  },
  methods: {
    async batchdelete(){
      if (!this.dictionariesList.length) {
        this.$message({
          message: '请选择字典类型',
          type: 'warning'
        });
        return false;
      }
      let deletes = []
      this.dictionariesList.map((item) =>{
        deletes.push(item.id)
      })
      let params = {
        idList:deletes
      }
      this.$confirm('是否批量删除所选数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.BatchDelete(params)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async BatchDelete(params){
      let res = await setDictTypeBatchDelete(params)
      if (res.data.code == 200) {
        this.$message({
          message: '批量删除成功',
          type: 'success'
        });
        this.onSearch()
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: 'warning'
        });
      }
    },
    async batchdeleteTwo(){
      console.log(this.dictionariesListTwo)
      if (!this.dictionariesListTwo.length) {
        this.$message({
          message: '请选择字典条目',
          type: 'warning'
        });
        return false;
      }
      let deletes = []
      this.dictionariesListTwo.map((item) =>{
        deletes.push(item.id)
      })
      // setItemBatchDelete
      let params = {
        idList:deletes
      }
      let res = await setItemBatchDelete(params)
      if (res.data.code == 200) {
        this.$message({
          message: '批量删除成功',
          type: 'success'
        });
        this.onSearchTwo()
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: 'warning'
        });
      }
    },
    handleSelectionChange(val){
      console.log(val)
      this.dictionariesList = val;
    },
    handleSelectionChangeTwo(val){
      console.log(val)
      this.dictionariesListTwo = val;
    },

    goBack(){
      this.st = 1
      this.queryDictionaries()
    },
    // 查询条目列表
    async onSearchTwo(){
      let params = {
        dictType: this.formData.dictType,
        itemLabel: this.formData.itemLabel,
        page: this.pageTwo.page,
        size: this.pageTwo.size,
        status: this.formData.status,
        data: true,
        pid: -1
      }
      console.log(params)
      const res = await dictItemRoot(params);
      if (res.data.code == 200) {
        this.tableDataTwo = res.data.data.dataList ? res.data.data.dataList : [];
        this.totalTwo = res.data.data.total ? Number(res.data.data.total) : 0;
      }
    },
    getDetailData(val){
      this.formData.dictType = val.dictType;
      this.st = 2;
      this.onSearchTwo()
    },
    async getValueDialog(val){
      if (val.status == true) {
        this.ruleForm.status = 1
      } else {
        this.ruleForm.status = 0
      }
      this.dialogVisible = true;
      this.title = '编辑字典项'
      this.ruleForm.dictName = val.dictName;
      this.ruleForm.dictType = val.dictType;
      this.ruleForm.dictOrder = val.dictOrder

      this.ruleForm.remark = val.remark;
      this.ruleForm.id = val.id;
    },
    // 删除字典类型
    async deleteType(val){
      if((this.total - 1) % this.page.size === 0) {
        if(this.page.page > 1) {
          this.page.page -= 1
        }
      }
      let params = {
        idList:[val.id]
      }
      let res = await setDictTypeBatchDelete(params)
      if (res.data.code == 200) {
            this.queryDictionaries()
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: 'warning'
        });
      }
      // this.$axios.get(`/dict/type/delete/${val.id}`).then((res) =>{
      //   if (res.data.code == 200) {
      //     this.queryDictionaries()
      //   } else {
      //     this.$message({
      //       message: `${res.data.msg}`,
      //       type: 'warning'
      //     });
      //   }
      // })
    },
    async deleteTypeTwo(val){
      let params = {
        idList:[val.id]
      }
      let res = await setItemBatchDelete(params)
      if (res.data.code == 200) {
        this.onSearchTwo()
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: 'warning'
        });
      }
    },
    async cancelcerat(){
      let xx = true
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          xx = true
        } else {
          xx = false
        }
      });
      if (xx == false) {
        this.$message({
          message: '请输入或选择必填项',
          type: 'warning'
        });
        return false;
      }
      let params = {
        dictName: this.ruleForm.dictName,
        dictType: this.ruleForm.dictType,
        status: this.ruleForm.status,
        remark: this.ruleForm.remark,
        dictOrder: Number( this.ruleForm.dictOrder),
        id: this.ruleForm.id,
      }
      const res = await AddDictionaryType(params)
      if (res.data.code == 200) {
        this.ruleForm.dictName = '';
        this.ruleForm.dictType = '';
        this.ruleForm.status = '';
        this.ruleForm.remark = '';
        this.ruleForm.id = '';
        this.queryDictionaries()
        this.dialogVisible = false;
        this.$message({
          message: '保存成功',
          type: 'success'
        });
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: 'warning'
        });
      }
    },
    async cancelceratTwo(){
      if (this.ruleFormTwo.itemLabel == '' || this.ruleFormTwo.itemLabel == null || this.ruleFormTwo.dictType == '' || this.ruleFormTwo.dictType == null) {
        this.$message({
          message: '请输入或选择必填项',
          type: 'warning'
        });
        return false;
      }
      if(this.ruleFormTwo.pid) {
        let params = {
          itemLabel:this.ruleFormTwo.itemLabel,
          itemName: this.ruleFormTwo.itemName,
          status: this.ruleFormTwo.status,
          remark:this.ruleFormTwo.remark,
          id: this.ruleFormTwo.id,
          dictType:this.ruleFormTwo.dictType,
          itemOrder : Number(this.ruleFormTwo.itemOrder),
          pid: this.ruleFormTwo.pid
        }
        const res = await dictItemAdd(params)
        if (res.data.code == 200) {
          this.ruleFormTwo.itemLabel = ''
          this.ruleFormTwo.itemName = ''
          this.ruleFormTwo.status = 1
          this.ruleFormTwo.remark = ''
          this.ruleFormTwo.id = ''
          this.ruleFormTwo.dictType = ''
          this.dialogVisibleTwo = false;
          this.tableDataTwo = []
          this.onSearchTwo()
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: 'warning'
          });
        }
      } else {
        let params = {
          itemLabel:this.ruleFormTwo.itemLabel,
          itemName: this.ruleFormTwo.itemName,
          status: this.ruleFormTwo.status,
          remark:this.ruleFormTwo.remark,
          id: this.ruleFormTwo.id,
          dictType:this.ruleFormTwo.dictType,
          itemOrder : Number(this.ruleFormTwo.itemOrder),
          pid: -1
        }
        const res = await dictItemAdd(params)
        if (res.data.code == 200) {
          this.ruleFormTwo.itemLabel = ''
          this.ruleFormTwo.itemName = ''
          this.ruleFormTwo.status = 1
          this.ruleFormTwo.remark = ''
          this.ruleFormTwo.id = ''
          this.ruleFormTwo.dictType = ''
          this.dialogVisibleTwo = false;
          this.onSearchTwo()
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: 'warning'
          });
        }
      }

    },
    getValueDialogTwo(val){
      if (val.status == true) {
        this.ruleFormTwo.status = 1
      } else {
        this.ruleFormTwo.status = 0
      }
      this.dialogVisibleTwo = true;
      this.titleTwo = '修改字典项'
      this.ruleFormTwo.itemLabel = val.itemLabel
      this.ruleFormTwo.itemName = val.itemName
      this.ruleFormTwo.remark = val.remark
      this.ruleFormTwo.id = val.id
      this.ruleFormTwo.dictType = val.dictType
      this.ruleFormTwo.pid = val.pid
      this.ruleFormTwo.itemOrder = val.itemOrder
    },
    getchildeditDialog(){
      this.title = '添加字典项'
      this.ruleForm.dictName = '';
      this.ruleForm.dictType = '';
      this.ruleForm.status = 1;
      this.ruleForm.remark = '';
      this.ruleForm.id = '';
      this.ruleForm.dictOrder = null
      this.dialogVisible = true;
    },
    getchildeditDialogTwo(tit,val){
      if (tit == 'add') {
        this.ruleFormTwo.itemLabel = ''
        this.ruleFormTwo.itemName = ''
        this.ruleFormTwo.status = 1
        this.ruleFormTwo.remark = ''
        this.ruleFormTwo.id = ''
        this.ruleFormTwo.pid = ''
        this.ruleFormTwo.itemOrder = null
        this.titleTwo = '添加字典项数据'
        this.ruleFormTwo.dictType = this.formData.dictType
      } else {
        this.ruleFormTwo.itemLabel = ''
        this.ruleFormTwo.itemName = ''
        this.ruleFormTwo.status = 1
        this.ruleFormTwo.remark = ''
        this.ruleFormTwo.id = ''
        this.ruleFormTwo.itemOrder = null
        this.ruleFormTwo.pid = val.id
        this.titleTwo = '添加子字典项数据'
        this.ruleFormTwo.dictType = this.formData.dictType
      }
      this.dialogVisibleTwo = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.queryDictionaries();
    },
    handleSizeChangeTwo(val) {
      this.pageTwo.size = val;
      this.onSearchTwo();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.queryDictionaries();
    },
    handleCurrentChangeTwo(val) {
      this.pageTwo.page = val;
      this.onSearchTwo();
    },
    // 查询字典类型列表
    onSearch(){
      this.page.page = 1;
      this.page.Size = 10;
      this.currentPage = 1;
      this.queryDictionaries()
    },
    // 查询字典类型列表
    async queryDictionaries(){
      let params = {
        dictType:this.form.dictType,
        dictName:this.form.itemName,
        page:this.page.page,
        size:this.page.size,
        startTime:this.form.startTime,
        endTime:this.form.endTime,
        status: this.form.status,
        data:true,
        pid: -1
      }
      const res = await DictionaryTypeList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.dataList ? res.data.data.dataList : [];
        this.total = res.data.data.total ? Number(res.data.data.total) : 0;
      }
    },
    async treeLoad(tree, treeNode, resolve) {
      let params = {
        dictType:this.form.dictType,
        dictName:this.form.itemName,
        page:this.page.page,
        size:this.page.size,
        startTime:this.form.startTime,
        endTime:this.form.endTime,
        status: this.form.status
      }
      const res = await DictionaryTypeList(params);
      return resolve(res.data.data);
    },
    async treeLoadSon(tree, treeNode, resolve) {
      let params = {
        dictType: this.formData.dictType,
        itemLabel: this.formData.itemLabel,
        page: this.pageTwo.page,
        size: this.pageTwo.size,
        status: this.formData.status,
        pid: tree.data.id,
        data: true
      }
      const res = await  DictionaryItemList(params)
      // let result = res.data
      // const res = await getDeptTreet(params);
      return resolve(res.data.data);
    },
    // 查询字典选择框列表
    async queryOptionList(){
      const res = await dictTypeOption();
      if (res.data.code == 200) {
        console.log(res.data)
        // this.parentTenantIdArr = res.data.data ? res.data.data : [];
      }
    },
  },
}
</script>
<style scoped lang="less">
.box-father {
  height: 100%;
  width: 100%;
  padding: 0px 20px 20px 20px;
  background-color: #fff;
}
.box-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #D8D8D8;
}
.box-header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.box-header-left-text {
  width: 120px;
  height: 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #B2B3C9;
  line-height: 21px;
  display: flex;
  align-items: center;
}
.box-header-right {
  font-weight: 400;
  color: #004AD1;
  line-height: 21px;
  width: 90%;
  height: 81%;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
.section {
  height: 94.9%;
  background-color: #fff;
}
.el-menu-item.is-active {
  background: rgb(59, 121, 203, 0.2) !important;
}
.el-menu-item:hover {
  color: #1e90ff;
}
.daohang {
  display: flex;
  margin-left: 15px;
}
.daohang .el-menu-item {
  width: 100px;
  margin-left: 20px;
}
.biaodan {
  width: 100%;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 70px;
  .form-item{
    padding: 0;
    margin: 0;
  }
}
.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.biaodan-left .el-form-item {
  margin-bottom: 0px;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
}
.export {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
/* .aside{
  height: 100%;
}
.disTable{
  height: 100%;
} */
.element.style {
  height: 570px;
}
/* .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 -28px !important;
} */
///deep/ .el-tabs__item {
//  height: 45px !important;
//  margin-top: 15px;
//}
.form-box {
  width: 100%;
  //display: flex;
  //flex-wrap: wrap;
  margin-top: 10px;
}
.form-content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.form-item {
  display: flex;
  justify-content: left;
}
.form-content-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ ::-webkit-scrollbar-thumb {
  background-color: #dbdde3;
  border-radius: 5px;
}
.botton-box{
  //width: 20%;
  height: 50px;
  display: flex;
  align-items: center;
}
.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}
//.el-form--inline .el-form-item__content {
//  width: 70%;
//}
.el-form-item__label {
  text-align: right;
}

.addValueDialog .el-form--inline .el-form-item {
  width: 100%;
}
.black{
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.aside .el-button {
  padding: 0;
}
@media screen and (max-width: 1855px) {
  .biaodan {
    height: 100px;
  }
}
/deep/ .table_name {
  table {
    tbody {
      tr {
        td:nth-child(2) .cell {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
/deep/ .table_name {
  table {
    tbody {
      tr {
        td:nth-child(2){
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/systemManagement/dictionaryManagement/index.vue